export const twoFactorAuthenticationStates = {
  inactive: 1,
};
